import {
    DIAGNOSTIC_REPORT,
    DIAGNOSTIC_REPORT_ERROR,
    DIAGNOSTIC_REPORT_SUCCESS,
    DIAGNOSTIC_REPORT_FILTERS,
    DIAGNOSTIC_REPORT_FILTERS_ERROR,
    DIAGNOSTIC_REPORT_FILTERS_SUCCESS
} from '../constants/diagnosticReportConstant';


const initialState = {
    loading: false,
    success: false,
    logged: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
};


function diagnosticReportReducer(state = initialState, action) {
    switch (action.type) {
        case DIAGNOSTIC_REPORT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DIAGNOSTIC REPORT',
                'loadingMessage': 'THE DIAGNOSTIC REPORT IS BEING LOADED',
                'type': action.type

            });
        case DIAGNOSTIC_REPORT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'logged': false,
                'error': action,
                'type': action.type
            });
        case DIAGNOSTIC_REPORT_SUCCESS:
            if (state.diagnosticData && action.page !== 0) {
                const oldDiagnostic = state.diagnosticData.filter(diagnostic => !action.data.data.some(diag => diag._id === diagnostic._id));
                action.data.data = oldDiagnostic.concat(action.data.data);
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'logged': true,
                'error': '',
                'type': action.type,
                'diagnosticData': action.data.data,
                'totalReports': action.data.totalDevices,
            });
        case DIAGNOSTIC_REPORT_FILTERS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DIAGNOSTIC REPORT',
                'loadingMessage': 'THE FILTERS ARE BEING LOADED',
                'type': action.type
            });
        case DIAGNOSTIC_REPORT_FILTERS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DIAGNOSTIC_REPORT_FILTERS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'filters': action.data,
                'type': action.type
            });
        default:
            return state;
    }
};

export default diagnosticReportReducer